<template>
  <v-card ref="groupcard"  class="pl-2 pr-2" :class="[isExpanded ? 'grpExpanded' : 'grpClosed']">
    <v-card-title :class="{margins,'title':isExpanded,'body-2':!isExpanded}" class="mb-1 pa-0 pt-2 cardTitle clickable" v-if="title" @click="isExpanded = !isExpanded">
      <div :class="{titleTextLimit:isExpanded && $slots.btn}" class="text-truncate">{{title}}</div>
      <div class="cardTitle expandedicon">
        <v-icon v-if="isExpanded">keyboard_arrow_up</v-icon>
        <!-- <v-icon v-else>keyboard_arrow_down</v-icon> -->
      </div>
    </v-card-title>

    <div  v-show="isExpanded" >
      <slot></slot>
      <div class="slotBtn">
        <slot name="btn"></slot>
      </div>
    </div>

    <div class="pl-0 pb-2 clickable" v-show="!isExpanded"  @click="isExpanded = !isExpanded">
        <slot name="compact"></slot>
    </div>
    </v-card>
</template>

<script>
  export default {
    name: 'GatGroup',
    props:['title','borders','padding','collapsed','readonly'],
    // inject:['getFormReadonly'],
    inject: {
      getFormReadonly: {
        from: 'getGroupReadonly'
      }
    },
    provide:  function() {
      return {
        getGroupReadonly: this.getReadonly,
      }
    },

    data:function(){
      return{
        isExpanded : true,
      }
    },

    created(){
      this.isExpanded = !this.collapsed;
    },

    watch:{
      isExpanded(newValue,oldValue){
        if(!newValue && oldValue){
            this.$emit('collapsed');
        } else{
          // this.$refs.groupcard.$el.scrollIntoView(true);
        }
      },
      collapsed(){
        this.isExpanded = !this.collapsed;
      }
    },

    computed:{
        isReadonly(){
          return this.readonly;
        },

        margins(){
          let result = "ml-3";
          //if phone
          if (this.$vuetify.breakpoint.xsOnly){
            result = "ml-2";

          }
          return result;
        }
    },

    methods:{
      getReadonly(){
        if(typeof this.readonly != 'undefined'){
          return this.readonly
        } else{
          return this.getFormReadonly();
        }
      },

    }

    }
</script>

<style scoped>

  .cardTitle{
    color:var(--gatGroupCaption);

  }

  .compactslot{
    padding-left: 40px;
  }

  .titleTextLimit{
    max-width: calc(100% - 130px);
  }

  .clickable{
    cursor: pointer;
  }

  .expandedicon{
    margin-left:10px;

  }

  .grpExpanded{
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .grpClosed{
    margin-top: 1px;
    margin-bottom: 0px;
  }

  .slotBtn{
    position: absolute;
    top:0px;
    right:0px;
    margin-top: 0px;
  }

</style>
